import { render, staticRenderFns } from "./BlogPosts.vue?vue&type=template&id=177a3363&scoped=true"
import script from "./BlogPosts.vue?vue&type=script&lang=js"
export * from "./BlogPosts.vue?vue&type=script&lang=js"
import style0 from "./BlogPosts.vue?vue&type=style&index=0&id=177a3363&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177a3363",
  null
  
)

export default component.exports